import { Link } from 'react-router-dom';
import { COMPANY } from '@/config/constants';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="ftr">
      <div className="ftr-inner">
        <div className="ftr-brand">
          {COMPANY.brandKo} ({COMPANY.brandEn})
          <span className="dot">·</span>
          {COMPANY.tagline}
        </div>

        <div className="ftr-info">
          서비스 공급자: {COMPANY.legalNameKo}
          <span className="sep">·</span>대표이사: {COMPANY.ceo}
          <span className="sep">·</span>사업자등록번호: {COMPANY.businessNumber}
          <br />
          {COMPANY.address} {COMPANY.addressDetail}
        </div>

        <p className="ftr-disclaimer">
          {COMPANY.legalNameKo}는 컨설팅 서비스 제공자로서 직접 세무대리, 회계 감사,
          법률 사무, 변리 사무 등 관련 자격이 필요한 업무를 수행하지 않으며,
          <br />
          이러한 업무는 제휴 세무사사무소·회계법인·법률사무소·특허법인 등
          자격을 갖춘 전문기관이 별도의 계약을 통해 수행합니다.
          <br />
          정책자금·정부지원사업 등의 신청 결과는 관련 정부 기관 및 공공기관의
          심사·결정에 따릅니다.
        </p>

        <div className="ftr-meta">
          <span className="ftr-copy">
            © {year} {COMPANY.legalNameKo.replace('주식회사 ', '')} | {COMPANY.brandKo} 서비스. All rights reserved.
          </span>
          <div className="ftr-links">
            <Link to="/privacy">개인정보처리방침</Link>
            <Link to="/terms">이용약관</Link>
            <a href="#contact">문의하기</a>
          </div>
        </div>
      </div>
    </footer>
  );
}